import * as React from 'react';
import { FieldType } from '..';
import { FormState } from 'informed';
import { TextField, FormFieldProps, InputModel } from '../InputField';
import { SelectField } from '../SelectField/SelectField';
import { RadioField, RadioModel } from '../RadioField';
import { SelectFieldModel } from '../SelectField';

export interface RenderFieldsProp<M> {
  field: FieldType;
  formState: FormState<M>;
  index: string | number;
}

export function renderFields<M>(props: RenderFieldsProp<M | {}>): React.ReactElement<FormFieldProps<InputModel | SelectFieldModel | RadioModel>> | null {
  const {
    field,
    formState,
    index,
  } = props;
  
  const error = formState && formState.errors && formState.errors[index] && formState.errors[index].length > 0 ? true : false ;
  const touched = formState && formState.touched && formState.touched[index] ? true : false;
  
  const fieldId = `register_form_account_${field.name}_${index}`;
  
  const type = field.type === 'group' || field.type === 'radio' || field.type === 'checkbox' || field.type === 'select' ? field.type : 'text' ;
  if (formState.pristine && formState.values && formState.values[field.name]) {
    field.value = formState.values[field.name];
  }

  const formFieldProps = {
    fieldId,
    field, 
    error, 
    touched,
  };

  switch (type) {
    case 'checkbox':
    case 'text':
      return <TextField autocomplete={field.autocomplete} {...formFieldProps as FormFieldProps<InputModel>} />;
    case 'select': 
      return <SelectField {...formFieldProps as FormFieldProps<SelectFieldModel>} />;
    case 'radio':
      return <RadioField {...formFieldProps as FormFieldProps<RadioModel>} />;
    default: 
      return null;
  }
}